import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { DependenciesResponse, DependencyQueryWithFilters } from '../../../../shared/dependenciesV2';

function getDependencies(locator: string, params: DependencyQueryWithFilters) {
  return get<DependenciesResponse>(`/api/v2/revisions/${nuc(locator)}/dependencies`, false, params);
}

const getDependenciesQueryKey = (locator: string, params: DependencyQueryWithFilters): QueryKey => [
  'revisions',
  locator,
  'dependencies',
  params,
];

/**
 * Hook to fetch dependencies for a given project locator.
 *
 * @param {string} locator - The locator of the project revision.
 * @param {DependencyQueryWithFilters} params - The parameters for the query.
 * @param {boolean} [shouldFetch] - Whether to fetch the dependencies.
 */
export default function useDependencies(
  locator: string,
  params: DependencyQueryWithFilters,
  shouldFetch = true,
) {
  return useQuery({
    queryFn: () => getDependencies(locator, params),
    queryKey: getDependenciesQueryKey(locator, params),
    enabled: shouldFetch,
  });
}
